import { configureStore } from "@reduxjs/toolkit";
import profile from "./profile";
import permissions from "./permissions";
const store = configureStore({
  reducer: { profile, permissions },
});
export type RootState = ReturnType<typeof store.getState>;
export default store;
